// extracted by mini-css-extract-plugin
export default {"navigation":"oOEdKQpRTqpotgqdBIGH","actions":"qyp3IFt2E1yOQO6UsfE9"};